import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PARTICIPANTS_REFERENCE_DATA_URL } from '../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getParticipantsReferenceData = createAsyncThunk(
  'stop/getParticipantsReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(PARTICIPANTS_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const participantsReferenceDataSlice = createSlice({
  name: 'stop/participantsReferenceData',
  initialState: null,
  reducers: {
    resetParticipantsReferenceData: () => null,
  },
  extraReducers: {
    [getParticipantsReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetParticipantsReferenceData } =
  participantsReferenceDataSlice.actions;

export default participantsReferenceDataSlice.reducer;
